module.exports = __webpack_public_path__ + "media/header-logo.f47909cd.svg";